import { render, staticRenderFns } from "./ClubRecommendation.vue?vue&type=template&id=77e6af72&"
import script from "./ClubRecommendation.vue?vue&type=script&lang=js&"
export * from "./ClubRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ClubRecommendation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports